import { createSelector } from "reselect";
import { RootState } from "../";

export const apiHeadersSelector = createSelector(
  (state: RootState) => state.auth.data.token,
  (state: RootState) => state.config.slug,
  (state: RootState) => state.config.locale,
  (state: RootState) => state.client.data.id,
  (token, clientSlug, locale, clientId) => ({
    token: token || "",
    clientSlug: clientSlug || "",
    locale: locale || "en",
    clientId: clientId.toString() || "",
  })
);
